/* ===========================================================================
   Hide Mailchimp's minimized "Claim 10% off" pill on product pages (AC-2014)
   ---------------------------------------------------------------------------
   Loaded from layout/theme.liquid on product templates only. On phones the pill
   (fixed, bottom-left) sits on top of the always-visible <sticky-atc> bar.

   The Mailchimp app embed renders its popup inside an open shadow root on
   `div.mcforms-wrapper` (appended to <body> once, after cookie consent), so
   theme CSS cannot reach it; we adopt a stylesheet into that shadow root. Only
   the pill is hidden: the full popup still opens on a product page, and the
   pill still shows on every other page.

   `#el_LmpuMVbno2` is the root element of the experience's "fallback" step
   (front_id 0up7EiZoh, "2nd Chance Container"), read from
   form-assets.mailchimp.com/snippet/config/22723391/variation/1069995
   (steps[type=fallback]). A Mailchimp redesign or a new variation changes this
   id SILENTLY: the pill comes back and nothing errors. Re-read the config.
   =========================================================================== */
(function () {
  "use strict";

  var HIDE_CSS = "@media (max-width: 767px) { #el_LmpuMVbno2 { display: none !important; } }";
  var STYLE_ATTR = "data-ac-mc-teaser-hide";
  var MAX_SHADOW_RETRIES = 20;
  var sheet = null;
  var patched = typeof WeakSet === "function" ? new WeakSet() : null;

  function canAdopt(root) {
    return (
      "adoptedStyleSheets" in root &&
      typeof CSSStyleSheet === "function" &&
      "replaceSync" in CSSStyleSheet.prototype
    );
  }

  function ensureStyleElement(root) {
    if (root.querySelector("style[" + STYLE_ATTR + "]")) return;
    var style = document.createElement("style");
    style.setAttribute(STYLE_ATTR, "");
    style.textContent = HIDE_CSS;
    root.appendChild(style);
  }

  function patchHost(host, attempt) {
    if (patched && patched.has(host)) return;
    var root = host.shadowRoot;
    if (!root) {
      // Mailchimp attaches the shadow root before appending the host, but do
      // not depend on that ordering.
      if ((attempt || 0) < MAX_SHADOW_RETRIES) {
        window.setTimeout(function () {
          patchHost(host, (attempt || 0) + 1);
        }, 250);
      }
      return;
    }

    if (canAdopt(root)) {
      if (!sheet) {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(HIDE_CSS);
      }
      // Append, never replace: Mailchimp may own sheets of its own here.
      var current = Array.prototype.slice.call(root.adoptedStyleSheets);
      if (current.indexOf(sheet) === -1) {
        root.adoptedStyleSheets = current.concat([sheet]);
      }
    } else {
      // Older Safari: a <style> in the shadow root. The renderer may drop
      // children it does not own, so put it back if it disappears.
      ensureStyleElement(root);
      new MutationObserver(function () {
        ensureStyleElement(root);
      }).observe(root, { childList: true });
    }

    if (patched) patched.add(host);
  }

  function scan(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 1 && node.classList.contains("mcforms-wrapper")) {
        patchHost(node, 0);
      }
    }
  }

  function start() {
    scan(document.querySelectorAll(".mcforms-wrapper"));
    // Childlist of <body> only (no subtree): the host is a direct child.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        scan(mutations[i].addedNodes);
      }
    }).observe(document.body, { childList: true });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start);
  }
})();
